<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <span slot="header">搜索</span>
        <el-form :model="search"
                 ref="searchForm"
                 label-width="96px"
                 label-position="right"
                 size="medium"
                 @submit.native.prevent="onSearch()">
          <div class="re-el-form__flex">
          <el-form-item label="手机号"
                        prop="cellphone">
            <el-input placeholder="请输入手机号"
                      v-model="search.cellphone"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="用户ID"
                        prop="userid">
            <el-input placeholder="请输入用户ID"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit">搜索
            </el-button>
            <el-button icon="sj-icon-export"
                       @click="onExportSearch()">导出报表
            </el-button>
          </el-form-item>
        </el-form>
    </layout-panel>
    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%"
                @sort-change="sortChange">
        <el-table-column prop="userid"
                         label="用户ID"
                         sortable="custom">
          <template slot-scope="scope">
            <router-link :to="{ path: '/users/detail/info?userid='+scope.row.userid}">
              {{scope.row.userid}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="姓名"></el-table-column>
        <el-table-column prop="points"
                         label="零豆余额"
                         sortable="custom"></el-table-column>
        <el-table-column prop="frozenpoints"
                         label="冻结零豆"
                         sortable="custom"></el-table-column>
        <el-table-column prop="spendpoints"
                         label="已花费零豆"
                         sortable="custom"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <router-link :to="{path: '/users/point?userid='+scope.row.userid}">
              <el-button size="mini"
              > 查看用户零豆明细
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      search: {
        sortOrder: 'desc',
        sortField: 'userid',
        cellphone: '',
        userid: ''
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      exportHeader: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'points',
          text: '零豆余额',
        },
        {
          key: 'frozenpoints',
          text: '冻结零豆',
        },
        {
          key: 'spendpoints',
          text: '已花费零豆',
        },
        {
          key: 'realname',
          text: '姓名',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      console.log(this.search)
      return request.page('getUserPointsList', params)
    },
    sortChange (column, prop, order) {
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop) {
        this.search.sortOrder = sortBy
        this.search.sortField = column.prop
      }
      this.onSearch()
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        request: (params) => request('getUserPointsList', {...this.search, ...params}),
        total: this.pagination.total,
        fileHeader: this.exportHeader,
      })
    },
  },
}
</script>


<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/users/pages/UsersPointsTable.vue